<template>
  <div id="page-user-edit">
    <page-title :title="title" />
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Main Info" icon-pack="feather" icon="icon-user">
            <div class="tab-text" >
              <profile-edit
                @addnew="(value) => addnew(value)"
                @cancel="(value) => cancel(value)"
                @updateRow="(value) => updateRow(value)"
                class="mt-4"
                :endPoint="settings.tableSettings.route"
                :addionalData="settings.tableSettings.additionalData"
              />
              <vs-button
                class="ml-4 mt-2"
                type="border"
                color="warning"
                @click="cancelChanges()"
              >Back to List</vs-button>
            </div>
          </vs-tab>
          <template v-for="(val,id) in pagetabDatas">
            <vs-tab :key="id" :label="val.label" icon-pack="feather" :icon="val.icon">
              <div class="tab-text">
                <advance-table :key="settings.route" :mainSettings="val"></advance-table>

                <vs-button
                  class="ml-4 mt-2"
                  type="border"
                  color="warning"
                  @click="cancelChanges()"
                >Back to Profile</vs-button>
              </div>
            </vs-tab>
          </template>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import profileEdit from "../profile_edit.vue";
import PageTitle from "../../components/aron/pageTitle";
import AdvanceTable from "./advance_table.vue";
import { mapGetters } from "vuex";

import axios from "@/axios.js";

import { settingsMixin } from "./settingsMixin";
export default {
  mixins: [settingsMixin],
  components: {
    profileEdit,
    PageTitle,
    AdvanceTable
  },
  data() {
    return {
      baseUrl: axios.defaults.baseURL,
      editPage: "edit_pr", //when user click the add new button
      uploadEndpoint: "/uploadFile",
      title: this.getEndPoint,
      endPoint: this.getEndPoint,
      activeTab: 0
    };
  },

  methods: {
    cancelChanges() {
      if (this.operation == "add") {
        this.$emit("changeView", "list");
      } else {
        this.$emit("changeView", "view");
        console.log("profile:",this.$store.state.profile.profileId);
     
      }


    },
    solveReactiveId() {
      return { pkId: this.$store.state.profile.profileId };
    },
  
    addnew(response) {
      //we need to set this record because the tabs will be needing this
      //as their foreignkeys
   

      this.$store.dispatch("profile/setProfileId", response.response.id);
      this.$store.dispatch("profile/setMainInfo", response.response);
     
    },
    updateRow(response) {
      //we need to set this record because the tabs will be needing this
      //as their foreignkeys
   console.log(" response.response.id:", response.response.id);


      this.$store.dispatch("profile/setProfileId", response.response.id);
      this.$store.dispatch("profile/setMainInfo", response.response);
     
    },
    cancel(response) {
      this.$emit("changeView", response);
    }
  },
  computed: {
    ...mapGetters({
      getCallBack: "profile/getCallBack",
      getMainInfo: "profile/getMainInfo",
      getUserInfo: "auth/getUserInfo"
    }),
    pagetabDatas() {
      return this.getTabDatas(this.$route.params.subject);
    },
    settings() {
      return this.getSettings(
        this.$route.params.subject,
        this.$route.params.key
      );
    },
    operation() {
      return Object.entries(this.getMainInfo).length > 0 ? "update" : "add";
    }
  },
  created() {
    console.log("create in Edit");
  }
};
</script>
